import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';

export default Form;
